import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Investors from "@/pages/Investors";
import Kit from "@/pages/Kit";
import Privacy from "@/pages/Privacy";
import CheckRedirect from "@/pages/CheckRedirect";
import NotFound from "@/pages/NotFound";

function App() {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "shescan");
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/investors" element={<Investors />} />
          <Route path="/kit" element={<Kit />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/check" element={<CheckRedirect />} />
          {/* Catch-all — MUST stay last so it does not shadow real routes. */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
